export enum RideAddPassengerViewStationsEnum {
  DisplayRideStations = "DisplayRideStations",
  DisplayRideAndCourseStations = "DisplayRideAndCourseStations",
  DisplayAllStations = "DisplayAllStations",
}
